import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
// import { AxiosResponse } from "axios";

export default {
    async list(): Promise<types.ResBannerPopupList> {
        const res = {} as types.ResBannerPopupList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/banner/popup/list", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async add(param: types.ReqBannerPopup): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/banner/popup/add", formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modify(param: types.ReqBannerPopupForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/banner/popup/modify", formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async remove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/banner/popup/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
